import React, { useState } from 'react';
import { Box, Icon, IconSize } from '@bechtel/gds';
import { useEnvProvider, useAppUser } from '@bechtel/client-common';
import { useField } from 'formik';
import PipeIcon from '@bechtel/client-assets/dist/images/pipe-icon.svg';
import { LocationIconStyled, TextFieldStyled } from './styled';
import { ErrorField } from '~/components/atoms/error-field';
import { t } from '@lingui/macro';
import { MarkerType, Map } from '~/components/organisms/map';
export const WeldedLocation = ({ name }) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const { user } = useAppUser();
  const [showMap, setShowMap] = useState<boolean>(true);
  const { envConfig } = useEnvProvider();

  const projectLocationObj = user?.project?.projectConfiguration?.projectLocation;
  const maxLatitude = projectLocationObj?.maxLatitude;
  const maxLongitude = projectLocationObj?.maxLongitude;
  const minLatitude = projectLocationObj?.minLatitude;
  const minLongitude = projectLocationObj?.minLongitude;
  const lat = field?.value?.latitude;
  const lng = field?.value?.longitude;
  const markerList = field.value
    ? [
        {
          id: 'location',
          markerType: MarkerType.PIPING,
          position: { lat, lng },
          icon: PipeIcon,
        },
      ]
    : [];

  const mapCenter: google.maps.LatLngLiteral =
    maxLatitude && maxLongitude && minLatitude && minLongitude
      ? {
          lat: (minLatitude + maxLatitude) / 2,
          lng: (minLongitude + maxLongitude) / 2,
        }
      : {
          lat,
          lng,
        };

  return (
    <Box mb={{ sm: '500' }} style={{ position: 'relative' }} flexDirection={{ sm: 'column' }}>
      <TextFieldStyled
        disabled={true}
        {...field}
        value={
          !!field?.value?.latitude && !!field?.value?.longitude
            ? `${field?.value?.latitude},${field?.value?.longitude}`
            : ''
        }
        placeholder={t`Welded Location`}
      ></TextFieldStyled>
      <LocationIconStyled>
        <Icon
          style={{ cursor: 'pointer' }}
          icon="map-marker-alt"
          size={IconSize.LARGE}
          fillColor="blue.800"
          onClick={() => {
            setShowMap((show) => !show);
          }}
        />
      </LocationIconStyled>

      {meta.touched && meta.error ? <ErrorField error={meta.error} /> : null}
      {showMap && (
        <Box
          mt={{ sm: '550' }}
          style={{
            minHeight: '150px',
            width: '100%',
          }}
        >
          <Map
            apiKey={envConfig?.mapApiKey}
            zoom={14}
            center={mapCenter}
            markers={markerList}
            // setting the value using enum from google.maps.MapTypeId throwing google undefined error.needs debugging. With string, it's working fine.
            mapTypeId="satellite"
            onMapClick={(position: google.maps.LatLng | null) => {
              setValue({ latitude: position?.lat(), longitude: position?.lng() });
            }}
          />
        </Box>
      )}
    </Box>
  );
};
